<style>
     @media only screen and (max-width: 479px) {
  .esap{
    display: block;
  }
  .esap1{
    display: none;
  }
    
}
 @media only screen and (min-width: 479px) {
  
     .esap{
    display: none;
  }
  .esap1{
    display: block;
  }
}
</style>
<section class="section bg-light esap" id="features">
    <div class="container">
        <div class="row justify-content-center text-center">
            <div class="col-lg-12">
                <h3 class="fontt text-muted home-subtitle-center mx-auto home-subtitle mt-4 mb-0" style="font-size: 45px; color: rgb(0, 0, 0) !important;">A<strong style="font-family: 'Montserrat-Regular', sans-serif;color: rgb(0, 0, 0);">GENDA</strong></h3>
                <p class="pdtxt text-muted mt-3 title-subtitle mx-auto">Te invitamos a descubrir todo lo que tenemos
                    preparado para ti en nuestra agenda. Desde eventos culturales hasta concursos creativos, hay algo
                    para todos los gustos.</p>
            </div>
        </div>
        <div class="row mt-5 vertical-content">
            <div class="col-lg-5 offset-lg-1 mt-2">
                <div class="features-desc">
                    <h1>29 NOV 2023</h1>
                </div>
            </div>
            <div class="col-lg-6 mt-2">
                <div>
                    <a (click)="modal.open(contenido)">
                        <img src="./assets/images/29n.jpeg" alt="" class="img-fluid mx-auto d-block">
                    </a>
                </div>
            </div>
            
        </div>
        <ng-template #contenido let-modal>
            <div class="modal-fade" id="" tabindex="-1" role="dialog" aria-labelledby="modal1" aria-hidden="true"
                style="padding:0% !important;">
                <div class="modal-dialog" role="document" style="padding:0% !important; margin: 0% !important;">
                    <div class="modal-content" style="padding:0% !important;">

                        <div class="modal-body" style="padding:0% !important;">
                            <img src="./assets/images/29n.jpeg" width="100%" alt="">
                        </div>

                    </div>
                </div>
            </div>
        </ng-template>


        <div class="row mt-5 pt-5 vertical-content">
        <div class="col-lg-5 mt-2">
            <div class="features-desc">
                <h1>30 NOV 2023</h1>
        
            </div>
        </div>
            <div class="col-lg-6 offset-lg-1 mt-2">
                <div>
                    <a (click)="modal.open(contenido2)">
                        <img src="./assets/images/30n.jpeg" alt="" class="img-fluid mx-auto d-block">
                    </a>
                </div>
            </div>
            
        </div>

        <ng-template #contenido2 let-modal>
            <div class="modal-fade" id="" tabindex="-1" role="dialog" aria-labelledby="modal1" aria-hidden="true"
                style="padding:0% !important;">
                <div class="modal-dialog" role="document" style="padding:0% !important; margin: 0% !important;">
                    <div class="modal-content" style="padding:0% !important;">

                        <div class="modal-body" style="padding:0% !important;">
                            <img src="./assets/images/30n.jpeg" width="100%" alt="">
                        </div>

                    </div>
                </div>
            </div>
        </ng-template>

        <div class="row mt-5 vertical-content">
            <div class="col-lg-5 offset-lg-1 mt-2">
                <div class="features-desc">
                    <h1>01 DIC 2023</h1>
            
                </div>
            </div><div class="col-lg-6 mt-2">
                <a (click)="modal.open(contenido3)">
                    <img src="./assets/images/01n.jpeg" alt="" class="img-fluid mx-auto d-block">
                </a>
            </div>
            
        </div>

        <ng-template #contenido3 let-modal>
            <div class="modal-fade" id="" tabindex="-1" role="dialog" aria-labelledby="modal1" aria-hidden="true"
                style="padding:0% !important;">
                <div class="modal-dialog" role="document" style="padding:0% !important; margin: 0% !important;">
                    <div class="modal-content" style="padding:0% !important;">

                        <div class="modal-body" style="padding:0% !important;">
                            <img src="./assets/images/01n.jpeg" width="100%" alt="">
                        </div>

                    </div>
                </div>
            </div>
        </ng-template>
    </div>
</section>

<section class="section bg-light esap1" id="features">
    <div class="container">
        <div class="row justify-content-center text-center">
            <div class="col-lg-12">
                <h3 class="fontt text-muted home-subtitle-center mx-auto home-subtitle mt-4 mb-0"
                    style="font-size: 45px; color: rgb(0, 0, 0) !important;">A<strong
                        style="font-family: 'Montserrat-Regular', sans-serif;color: rgb(0, 0, 0);">GENDA</strong></h3>
                <p class="pdtxt text-muted mt-3 title-subtitle mx-auto">Te invitamos a descubrir todo lo que tenemos preparado para ti en nuestra agenda. Desde eventos culturales hasta concursos creativos, hay algo para todos los gustos.</p>
            </div>
        </div>
        <div class="row mt-5 vertical-content">
            <div class="col-lg-6 mt-2">
                <div>
            <a  (click)="modal.open(contenido)">
              <img src="./assets/images/29n.jpeg" alt="" class="img-fluid mx-auto d-block">
            </a>
                </div>
            </div>
            <div class="col-lg-5 offset-lg-1 mt-2">
                <div class="features-desc">
                    <h1>29 NOV 2023</h1>
                </div>
            </div>
        </div>
<ng-template #contenido let-modal>
    <div class="modal-fade" id="" tabindex="-1" role="dialog" aria-labelledby="modal1" aria-hidden="true" style="padding:0% !important;">
        <div class="modal-dialog" role="document" style="padding:0% !important; margin: 0% !important;">
            <div class="modal-content" style="padding:0% !important;">

                <div class="modal-body" style="padding:0% !important;">
                    <img src="./assets/images/29n.jpeg" width="100%" alt="">
                </div>

            </div>
        </div>
    </div>
</ng-template>
        
        
        <div class="row mt-5 pt-5 vertical-content">
            <div class="col-lg-5 mt-2">
                <div class="features-desc">
                    <h1>30 NOV 2023</h1>
                    
                </div>
            </div>
            <div class="col-lg-6 offset-lg-1 mt-2">
                <div>
                    <a (click)="modal.open(contenido2)">
                        <img src="./assets/images/30n.jpeg" alt="" class="img-fluid mx-auto d-block">
                    </a>
                </div>
            </div>
        </div>

<ng-template #contenido2 let-modal>
    <div class="modal-fade" id="" tabindex="-1" role="dialog" aria-labelledby="modal1" aria-hidden="true"
        style="padding:0% !important;">
        <div class="modal-dialog" role="document" style="padding:0% !important; margin: 0% !important;">
            <div class="modal-content" style="padding:0% !important;">

                <div class="modal-body" style="padding:0% !important;">
                    <img src="./assets/images/30n.jpeg" width="100%" alt="">
                </div>

            </div>
        </div>
    </div>
</ng-template>

        <div class="row mt-5 vertical-content">
            <div class="col-lg-6 mt-2">
                <a (click)="modal.open(contenido3)">
                    <img src="./assets/images/01n.jpeg" alt="" class="img-fluid mx-auto d-block">
                </a>
            </div>
            <div class="col-lg-5 offset-lg-1 mt-2">
                <div class="features-desc">
                    <h1>01 DIC 2023</h1>
                   
                </div>
            </div>
        </div>

        <ng-template #contenido3 let-modal>
            <div class="modal-fade" id="" tabindex="-1" role="dialog" aria-labelledby="modal1" aria-hidden="true"
                style="padding:0% !important;">
                <div class="modal-dialog" role="document" style="padding:0% !important; margin: 0% !important;">
                    <div class="modal-content" style="padding:0% !important;">
        
                        <div class="modal-body" style="padding:0% !important;">
                            <img src="./assets/images/01n.jpeg" width="100%" alt="">
                        </div>
        
                    </div>
                </div>
            </div>
        </ng-template>
    </div>
</section>
<!-- END FEATURES -->